import { getInstructionsServiceUrl, getItemInstructionsServiceUrl } from './instructionsUrl';
import { MAX_URL_LENGTH, RenderingUrlTooLargeError, buildRenderingBaseWithoutInstructions, buildRenderingUrl } from './renderingUrl';
const buildRenderingRequestFromRenderingUrl = ({ renderingUrl, view }) => {
    const instructions_uri = renderingUrl.searchParams.get('instructions_uri');
    const parsedInstructionsURL = new URL(instructions_uri);
    const documentUri = parsedInstructionsURL.searchParams.get('documentUri');
    const surfaceOrdinals = parsedInstructionsURL.searchParams.get('surfaceOrdinals');
    if (surfaceOrdinals) {
        renderingUrl.searchParams.set('instructions_uri', `${getInstructionsServiceUrl()}?surfaceOrdinals=${surfaceOrdinals}`);
    }
    else {
        renderingUrl.searchParams.set('instructions_uri', view.type === 'item' ? getItemInstructionsServiceUrl() : getInstructionsServiceUrl());
    }
    const postData = new FormData();
    postData.set('instructionsPostData', `{"documentUri":"${documentUri}"}`);
    return new Request(renderingUrl, {
        method: 'POST',
        body: postData,
    });
};
export const buildRenderingRequest = ({ cimDocUrl, referer, tenantId, view, width, bgColor, format, showerr }) => {
    try {
        const renderingUrl = buildRenderingUrl({ cimDocUrl, referer, tenantId, view, width, bgColor, format, showerr });
        return new Request(renderingUrl);
    }
    catch (e) {
        // Return a non cacheable POST request instead for too large urls
        if (e instanceof RenderingUrlTooLargeError) {
            const renderingUrl = new URL(e.renderingUrl);
            return buildRenderingRequestFromRenderingUrl({ renderingUrl, view });
        }
        throw e;
    }
};
export const buildRenderingRequestFromInstructionsUrl = ({ instructionsUrl, referer, tenantId, view, width, bgColor, format, showerr, }) => {
    try {
        const { baseUrl, params } = buildRenderingBaseWithoutInstructions({ referer, tenantId, view, width, bgColor, format, showerr });
        params.set('instructions_uri', instructionsUrl);
        const renderingUrl = `${baseUrl}?${params.toString()}`;
        if (renderingUrl.length >= MAX_URL_LENGTH) {
            throw new RenderingUrlTooLargeError(renderingUrl);
        }
        return new Request(renderingUrl);
    }
    catch (e) {
        // Return a non cacheable POST request instead for too large urls
        if (e instanceof RenderingUrlTooLargeError) {
            const renderingUrl = new URL(e.renderingUrl);
            return buildRenderingRequestFromRenderingUrl({ renderingUrl, view });
        }
        throw e;
    }
};
//# sourceMappingURL=renderingRequest.js.map